<template>
  <div>
    <div class="information">
       <van-list
        v-model="loading"
        :finished="finished"
        offset="30"
        @load="onLoad"
        finished-text="没有更多了"
        :immediate-check="false"

      >
        <!-- 全部 -->
         <div    class="boxBig">
          <div class="center borderClass" v-for="item in list" :key="item.index">
          <div @click="gotoUrl('/Changan-zhsq/NewsArticles/detail/' + item.RIId)">
            <div class="Content">
              <div
                style="display: inline-block; width: 100%"
                class="ContentA"
                ref="getHeight"
              >
                <img
                  v-if="item.Thematic"
                  style="border-radius: 5px; min-height: 50px; object-fit: cover"
                  :src="item.Thematic"
                  alt=""
                />
                <img
                  v-else
                  style="border-radius: 5px; min-height: 50px; object-fit: cover"
                  src="https://new-zhsq.oss-cn-beijing.aliyuncs.com/goodsImg/cdb4.png"
                  alt=""
                />
              </div>
              <div style="display: inline-block; width: 100%" class="ContentB">
                <div class="centerTitle van-multi-ellipsis--l2">
                  {{ item.Title }}
                </div>
                <span
                  class="centertime van-multi-ellipsis--l2"
                  style="margin: 5px 0px; font-size: 13px; color: #666666"
                  >{{ item.newti }}</span
                >
              </div>
              <div class="manBox">
        <img class="manBox_img" src="https://new-zhsq.oss-cn-beijing.aliyuncs.com/goodsImg/a2b5.png" />
        <span class="manBox_text">{{item.issMan}}</span>
        </div>
              <!-- <span
                class="centertime"
                style="float: right; margin-top: -10px; color: black"
                >{{ item.CreateTime | timeFilter }}</span
              > -->
            </div>
          </div>
        </div>
         </div>
       </van-list>
    </div>

    <!-- 发布活动 -->
    <!-- <div
      class="backTop"
      @click="gotoUrl('/article/addActivity')"
      v-if="isWorkMan == 1"
    >
      <img
        class="top_iamge"
        src="https://new-zhsq.oss-cn-beijing.aliyuncs.com/goodsImg/eae3.png" diaplsy
        alt=""
      />
    </div> -->
  </div>
</template>
<script>
import { setOpenId, getOpenId, getIsWorkMan } from "@/utils/auth";
// import { WeWorkreportPage } from "@/api/RealInfo";
import { trealinfoPage } from "@/api/Changan-zhsq/NewsArticles";
export default {
  data() {
    return {
      isWorkMan: "",
      tkId: 0, //tab栏
      activeName: "",
      list: [], //资讯列表
      listfrom: {
        page: 1,
        limit: 10,
        pAKind:1

      }, //查询传参
      hidden: true, //没有更多数据了
      TitleList: [],
      loading: false, //加载
      finished: false, //数据完全加载结束为 true
    };
  },
  filters: {
    timeFilter(value) {
      if (value != undefined) {
        let gstime = value.replace("T", " ");
        return gstime;
      }
    },
  },
  methods: {
    // 发布活动
    //跳转到公共页面
    gotoUrl(path) {
      if (window.__wxjs_environment === "miniprogram") {
        window.wx.miniProgram.navigateTo({
          url: "../public/goto?path=" + path,
        });
      } else {
        this.$router.push(path);
      }
    },
    delHtmlTag(str) {
      if (!str) {
        return
      }
       str = str.replace(/<([a-z]+?)[^>]*>/g, '')
      return str.replace(/<\/([a-z]+?)+>/g, '') // 去掉所有的html标记
    },
    escape2Html(str) {
      if (!str) {
        return
      }
     return str.replace(/&+[a-zA-Z]+;/g, '')
    },
    // 获取分页列表
    getList() {
      this.listfrom.openId=this.$route.query["openid"];
      trealinfoPage(this.listfrom)
        .then((res) => {
          console.log(res);
          if (res.data.code == 0) {

            let rows = res.data.data; //请求返回当页的列表
            for (let i = 0; i < rows.length; i++) {
            const e = rows[i]
             const newti = this.delHtmlTag(e.content)
             e.newti = newti.replace(/&nbsp;/g, ' ');
          }
            console.log(rows);
            // 加载状态结束
            this.loading = false;

            if (res.data.code == 0) {
              if (rows == null || rows.length === 0) {
                // 加载结束
                console.log("结束");
                this.finished = true;
                this.hidden = true;
                return;
              }
              // 将新数据与老数据进行合并
              this.list = this.list.concat(rows);

              //如果列表数据条数>=总条数，不再触发滚动加载
              if (this.list.length >= res.data.count) {
                this.finished = true;
                this.hidden = true;
              }
            }
          }
        })
        .catch(() => {});
    },

    // 下拉加载更多
    onLoad() {
      console.log(123);
      this.listfrom.page = this.listfrom.page + 1;
      this.getList();
    },
  },
  mounted() {
    if (this.$route.query["openid"]) {
      setOpenId(this.$route.query["openid"]);
    }
    this.isWorkMan = getIsWorkMan();
    this.getList();
  },
};
</script>
<style scoped>
.hidden {
  text-align: center;
  font-size: 12px;
  color: #ccc;
  margin: 10px 0px 25px 0px;
}
.information {
  width: 95%;
  margin: auto;
}
.borderClass {
  padding: 0;
  /* box-shadow: 0px 5px 17px 1px rgb(0 0 0 / 7%); */
  width: 48%;
}
.borderClass .Content {
  padding: 8px;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  width: 100%;
}
.borderClass:nth-child(2n) .Content{
  margin-left: 4%;
}

.backTop {
  display: flex;
  position: fixed;
  bottom: 125px;
  right: 10px;
  width: 75px;
  height: 75px;
}

.top_image {
  width: 75px;
  height: 75px;
}
.boxBig{
  width: 96%;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  //display: flex;
  //align-items: flex-start;
  //width: 100%;
}
.manBox{
display: flex;
align-items: center;
margin-top: 7px;
}
.manBox_img{
width: 20px !important;
height: 20px;
}
.manBox_text{
font-size: 11px;
display: inline-block;
margin-left: 5px;
color:#888;
}
</style>
